import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

// Builder
import foldersSlice from './reducers/builder/folders.slice';
import folderSlice from './reducers/builder/folder.slice';
import armyListSlice from './reducers/builder/armyList.slice';
import armyListsSlice from './reducers/builder/armyLists.slice';
import armyListUnitSlice from './reducers/builder/armyListUnit.slice';
import myBuilderSlice from './reducers/builder/myBuilder.slice';

// Ninth Age
import versionsSlice from './reducers/ninthage/versions.slice';
import armySlice from './reducers/ninthage/army.slice';
import armyCategoriesSlice from './reducers/ninthage/army-categories.slice';
import armiesSlice from './reducers/ninthage/armies.slice';
import magicPathSlice from './reducers/ninthage/magic-path.slice';
import mapsSlice from './reducers/ninthage/maps.slice';
import mapSlice from './reducers/ninthage/map.slice';
import armyCategorySlice from './reducers/ninthage/army-category.slice';
import userFavoriteUnitsSlice from './reducers/ninthage/user-favorite-units.slice';

// Publication
import armyBooksSlice from './reducers/publication/army-books.slice';
import armyBookSlice from './reducers/publication/army-book.slice';
import booksSlice from './reducers/publication/books.slice';
import bookSlice from './reducers/publication/book.slice';
import bookSectionSlice from './reducers/publication/book-section.slice';

// Tournament
import contestsSlice from './reducers/tournament/contests.slice';
import myContestsSlice from './reducers/tournament/myContests.slice';
import myTeamsSlice from './reducers/tournament/myTeams.slice';
import myContestSlice from './reducers/tournament/myContest.slice';

// Tool - Pairing
import draftSlice from './reducers/tool/pairing/draft.slice';
import myTeamSlice from './reducers/tool/pairing/myTeam.slice';
import opponentTeamSlice from './reducers/tool/pairing/opponentTeam.slice';
import matchesSlice from './reducers/tool/pairing/matches.slice';
import myDrawSlice from './reducers/tool/pairing/myDraw.slice';
import opponentDrawSlice from './reducers/tool/pairing/opponentDraw.slice';
import pollingSlice from './reducers/polling.slice';

// Tool - Survey
import campaignsSlice from './reducers/tool/survey/campaigns.slice';

// Arsenal
import arsenalArmiesSlice from './reducers/arsenal/arsenal-armies.slice';
import arsenalArmySlice from './reducers/arsenal/arsenal-army.slice';

// User
import userPreferenceSlice from './reducers/user/user-preference.slice';
import annoncementSlice from './reducers/user/annoncement.slice';
import userBugReportSlice from './reducers/user/user-bug-report.slice';

// Federation
import clubsSlice from '@Redux/reducers/federation/clubs.slice';
import myClubsSlice from '@Redux/reducers/federation/my-clubs.slice';
import categoriesSlice from '@Redux/reducers/federation/categories.slice';
import playersSlice from '@Redux/reducers/federation/players.slice';

export default combineReducers({
  // General
  myBuilder: myBuilderSlice.reducer,

  // NinthAge
  versions: versionsSlice.reducer,
  army: armySlice.reducer,
  armyCategories: armyCategoriesSlice.reducer,
  armyCategory: armyCategorySlice.reducer,
  armies: armiesSlice.reducer,
  magicPath: magicPathSlice.reducer,
  maps: mapsSlice.reducer,
  userFavoriteUnits: userFavoriteUnitsSlice.reducer,
  map: mapSlice.reducer,

  // Builder
  folders: foldersSlice.reducer,
  folder: folderSlice.reducer,
  armyList: armyListSlice.reducer,
  armyListUnit: armyListUnitSlice.reducer,
  armyLists: armyListsSlice.reducer,
  form: formReducer,

  // Federation
  clubs: clubsSlice.reducer,
  myClubs: myClubsSlice.reducer,
  federationCategories: categoriesSlice.reducer,
  players: playersSlice.reducer,

  // Publication
  armyBooks: armyBooksSlice.reducer,
  armyBook: armyBookSlice.reducer,
  books: booksSlice.reducer,
  book: bookSlice.reducer,
  bookSection: bookSectionSlice.reducer,

  // Tool - Pairing
  draft: draftSlice.reducer,
  myTeam: myTeamSlice.reducer,
  opponentTeam: opponentTeamSlice.reducer,
  matches: matchesSlice.reducer,
  myDraw: myDrawSlice.reducer,
  opponentDraw: opponentDrawSlice.reducer,
  polling: pollingSlice.reducer,

  // Tool - Survey
  campaigns: campaignsSlice.reducer,

  // Arsenal,
  arsenalArmies: arsenalArmiesSlice.reducer,
  arsenalArmy: arsenalArmySlice.reducer,

  // Tournament
  contests: contestsSlice.reducer,
  myContests: myContestsSlice.reducer,
  myContest: myContestSlice.reducer,
  myTeams: myTeamsSlice.reducer,

  // User
  userPreference: userPreferenceSlice.reducer,
  annoncement: annoncementSlice.reducer,
  userBugReport: userBugReportSlice.reducer,
});
